import type * as Ably from 'ably'

export const isTokenValid = (token: Ably.TokenDetails): boolean =>
  token.expires > Date.now()
